import { Fade, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { Link, matchPath, useLocation } from "react-router";
import { useMcpDrawerContext } from "./drawer-context";

interface DrawerItemProps {
    Icon?: React.FC,
    title: string,
    to: string,
    paddingLeft?: number
}

export default function DrawerItem({
    Icon,
    title,
    to,
    paddingLeft = 0
}: DrawerItemProps) {
    const { pathname: currentPathName } = useLocation();
    const { drawerOpen } = useMcpDrawerContext();

    const match = matchPath(to, currentPathName);

    return <ListItemButton to={to} component={Link} selected={Boolean(match)} sx={{ pl: paddingLeft?paddingLeft:undefined }}>
        {Icon && <ListItemIcon> <Icon /> </ListItemIcon>}
        <Fade in={drawerOpen}>
            <ListItemText primary={<Typography noWrap>{title}</Typography>} />
        </Fade>
    </ListItemButton>
}